import moment from 'moment';

export function localeSort(str1 = '', str2 = '') {
  return str1.localeCompare(str2, 'en', {numeric: true});
}

export function dateStringSort(date1, date2) {
  if (!date1 || !date2) {
    return 0;
  }
  date1 = moment.utc(date1);
  date2 = moment.utc(date2);

  return date1.diff(date2);
}



// WEBPACK FOOTER //
// ./src/utils/sort.js